import { Component, OnInit, ViewChild, ChangeDetectorRef, Injector } from '@angular/core'; import { EMPTY } from 'rxjs';
import { toObservable } from '@angular/core/rxjs-interop';
import { FeedService, Feed, User, ListFeedsPayload, FeedFilterTree } from 'src/app/services/feed.service'; import { forkJoin, of, from } from 'rxjs';
import { switchMap, catchError, tap, finalize, map, mergeMap, filter } from 'rxjs/operators'; import { MenuItem } from 'primeng/api'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { MessageService } from 'primeng/api'; import { Observable, throwError } from 'rxjs';
import { Router } from '@angular/router'; import { ConfirmationService } from 'primeng/api'; import { ActivatedRoute } from '@angular/router';
import { GaleriaComponent } from 'src/app/components/galeria/galeria.component'; import { Capacitor } from '@capacitor/core';
import { getFeedFilterGroups, summarizeFeedFilterGroup } from 'src/app/models/feed-filter-rule.model';
import {
  InstagramGalleryService,
  FacebookPage, FacebookPageEdge,
  InstagramBusinessAccount, GraphEdgeResponse
} from 'src/app/services/instagram-gallery.service';
@Component({
  selector: 'app-feed',
  templateUrl: './feed.component.html',
  styleUrls: ['./feed.component.scss']
})
export class FeedComponent implements OnInit {
  feeds: Feed[] = [];
  activeSlicksCount = 0;
  maxSlicks = 10;
  progressValue = 0;
  progressValueFeeds = 0;
  uploadCount = 0;
  instagramCount = 0;
  youtubeCount = 0;
  tiktokCount = 0;

  allPublished = 0;
  allTotal = 0;

  uploadPublished = 0;
  uploadTotal = 0;
  instagramPublished = 0;
  youtubePublished = 0;
  instagramTotal = 0;
  tiktokPublished = 0;
  tiktokTotal = 0;

  recentIngests: any[] = [];
  // categories: { imagem?: number; video?: number } = {};
  categories: Record<string, number> = {};
  constructor(
    private feedService: FeedService,
    private errorHandler: ErrorHandlerService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private gallery: InstagramGalleryService,
    private messageService: MessageService,
    private router: Router, private confirmationService: ConfirmationService,
    private injector: Injector
  ) {
    console.log('[Capacitor] referenced in FeedComponent');
    }
  nextCursor: string | null = null;
  readonly limit = 9; activeFeedsCount: number = 0;
  userSubType!: number;
  globalInstagramAccounts = new Map<string, (InstagramBusinessAccount & { page_id: string })[]>();
  categoryEntries: { key: string; value: number }[] = [];

  displayPlans: boolean = false;
  isLoadingFeeds = true;
  skeletonArray = Array(6).fill(0);
  payload: any;
  isMobile = false;
  ngOnInit() { // 
    if (window.innerWidth <= 768) {
      this.isMobile = true;
    }

    if (Capacitor.isNativePlatform()) {
      this.route.queryParams.subscribe(params => {
        const integration = params['integration'];

        if (integration) {
          // Atualize sua lista, recarregue dados, mostre toast, etc.
          this.messageService.add({
            severity: 'success',
            summary: `Integração realizada com sucesso`,
            detail: `Integração concluída!`
          });

          // Remove os query params da url para não repetir ao recarregar
          setTimeout(() => {
            this.router.navigate([], { queryParams: {}, replaceUrl: true });
          }, 100);
        }
      });
    }
    // this.displayAguarde = true;
    const userId = Number(localStorage.getItem('user_id'));
    if (!userId) {
      console.error('user_id não encontrado no localStorage');
      return;
    }
    this.maxSlicks = this.calcMaxSlicks(0);

    this.feedService.getUser(userId).subscribe(user => {
      this.userSubType = user.sub_type;
      this.maxSlicks = this.calcMaxSlicks(user.sub_type);
    });

    // Cache-first com ETag (src/app/core/http-cache).
    const feedsResource = this.feedService.listFeedsRevalidated(this.limit, undefined);

    toObservable(feedsResource.data, { injector: this.injector }).pipe(
      filter((payload): payload is ListFeedsPayload => payload !== null)
    ).subscribe((payload: ListFeedsPayload) => {
        this.nextCursor = payload.nextCursor;
        this.payload = payload;
        // 1) atribui as coleções vindas da API
        this.feeds = payload.feeds;

        // Pre-popula selectedInstagramAccount com ig_username/ig_picture vindos do backend
        // (evita esperar o Graph API para exibir conta no dropdown)
        this.feeds.forEach((f: Feed) => {
          if (f.source_id === 'ig' && f.account_id && f.ig_username) {
            f.selectedInstagramAccount = {
              id: f.account_id,
              username: f.ig_username,
              picture: f.ig_picture ?? '',
              page_id: ''
            };
          }
        });

        ///////////////////////
        const facebookUserIds = payload.facebook_user_ids;

        from(facebookUserIds).pipe(
          mergeMap((facebookUserId: string) => {
            return this.gallery.listFacebookPages(10, undefined, facebookUserId).pipe(
              switchMap((res: any) => {
                const pages = res.data;
                const calls = pages.map((page: any) =>
                  this.gallery.getInstagramAccountForPage(page.id, facebookUserId).pipe(
                    map((acc: any): (InstagramBusinessAccount & { page_id: string }) | null =>
                      acc ? { ...acc, page_id: page.id, facebook_user_id: facebookUserId } : null
                    ),
                    catchError(() => of(null))
                  )
                );
                this.displayAguarde = false;
                return forkJoin(calls as Observable<(InstagramBusinessAccount & { page_id: string }) | null>[]).pipe(
                  map((results) => ({
                    facebookUserId,
                    validAccounts: results.filter(
                      (acc): acc is InstagramBusinessAccount & { page_id: string } =>
                        acc !== null && !!acc.id
                    )
                  }))
                );
              }),
              catchError(() =>
                of({
                  facebookUserId,
                  validAccounts: [] as (InstagramBusinessAccount & { page_id: string })[]
                })
              )
            );
          }),
          filter((res): res is { facebookUserId: string; validAccounts: (InstagramBusinessAccount & { page_id: string })[] } => !!res)
        ).subscribe({
          next: ({ facebookUserId, validAccounts }) => {
            // 1) Armazena no Map global
            this.globalInstagramAccounts.set(facebookUserId, validAccounts);

            // 2) Atualiza feeds com contas específicas
            this.feeds
              .filter((f: Feed) => f.account_id === facebookUserId)
              .forEach((f: Feed) => {
                f.instagram_accounts = validAccounts;
                f.selectedInstagramAccount = validAccounts.find(
                  (acc: InstagramBusinessAccount & { page_id: string }) => acc.username === f.instagram_username
                ) || validAccounts[0];
              });

            // 3) Atualiza todos os feeds com todas as contas
            const allAccounts = Array.from(this.globalInstagramAccounts.values()).flat();

            this.feeds.forEach((f: Feed) => {
              f.all_instagram_accounts = allAccounts;
            });
          },
          complete: () => {
            console.log('Todas as requisições de contas Meta finalizadas');
          }
        });

        ///////////////////////

        this.isLoadingFeeds = false;

        this.recentIngests = payload.ingests.map(item => ({
          ...item,
          isPublished: item.status === 1
        }));
        // (se você criou a prop `categories` no componente)
        this.categories = payload.categories;

        this.categoryEntries = Object.entries(this.categories).map(([key, value]) => ({ key, value }));

        // 2) agora use this.feeds em todos os seus cálculos, e tipando os callbacks:
        // Cache-first com ETag (src/app/core/http-cache).
        const countSlicksResource = this.feedService.countSlicksRevalidated();

        toObservable(countSlicksResource.data, { injector: this.injector }).pipe(
          filter((res): res is any => res !== null)
        ).subscribe(res => {
            this.activeSlicksCount = res.slicks;
            this.activeFeedsCount = res.feeds;

            // Atualiza também as progressões com base nesses novos valores:
            this.progressValue = this.activeSlicksCount / this.maxSlicks * 100;
            this.progressValueFeeds = this.activeFeedsCount / this.maxSlicks * 100;
        });

        toObservable(countSlicksResource.error, { injector: this.injector }).pipe(
          filter((error): error is any => error !== null)
        ).subscribe(error => {
            this.errorHandler.handle(error);
        });
        ////////////////////////

        // soma totais por categoria
        this.uploadCount = this.payload.liveShopsUploadCount;
        this.instagramCount = this.payload.liveShopsInstagramCount;
        this.youtubeCount = this.payload.liveShopsYoutubeCount;
        this.tiktokCount = this.payload.liveShopsTiktokCount;


        this.uploadPublished = this.payload.liveShopsUploadCountPublished;
        this.instagramPublished = this.payload.liveShopsInstagramCountPublished;
        this.youtubePublished = this.payload.liveShopsYoutubeCountPublished;
        this.tiktokPublished = this.payload.liveShopsTiktokCountPublished;
        this.displayAguarde = false;
    });

    toObservable(feedsResource.error, { injector: this.injector }).pipe(
      filter((error): error is any => error !== null)
    ).subscribe(error => {
        this.displayAguarde = false;
        this.isLoadingFeeds = false;
        this.errorHandler.handle(error);
    });


    // Cache-first com ETag (src/app/core/http-cache).
    const plansResource = this.feedService.plansRevalidated();

    toObservable(plansResource.data, { injector: this.injector }).pipe(
      filter((res): res is any => res !== null)
    ).subscribe(res => {
        /////////////
        // Converter os preços para reais
        this.freePlanPrice = this.formatCurrency(parseFloat(res.free_plan_price));
        this.starterPlanPrice = this.formatCurrency(parseFloat(res.starter_plan_price));
        this.proPlanPrice = this.formatCurrency(parseFloat(res.pro_plan_price));
        this.enterprisePlanPrice = this.formatCurrency(parseFloat(res.enterprise_plan_price));

        // Converter visualizações para número formatado
        this.freePlanViews = this.formatNumber(parseFloat(res.free_plan_views));
        this.starterPlanViews = this.formatNumber(parseFloat(res.starter_plan_views));
        this.proPlanViews = this.formatNumber(parseFloat(res.pro_plan_views));
        this.enterprisePlanViews = this.formatNumber(parseFloat(res.enterprise_plan_views));



        this.free_plan_videos_count = res.free_plan_videos_count;
        this.starter_plan_videos_count = res.starter_plan_videos_count;
        this.pro_plan_videos_count = res.pro_plan_videos_count;
        this.enterprise_plan_videos_count = res.enterprise_plan_videos_count;


        this.free_plan_views_count = res.free_plan_views_count;
        this.starter_plan_views_count = res.starter_plan_views_count;
        this.pro_plan_views_count = res.pro_plan_views_count;
        this.enterprise_plan_views_count = res.enterprise_plan_views_count;

        // Outras variáveis
        this.hasShopify = res.hasShopify;
        this.userSubType = res.user_sub_type;
        this.subs_status = res.subs_status;


        /////////////
        if (this.userSubType == 0) {
          this.plan = 'Free';
          this.views_total = this.free_plan_views_count;
          this.slicks_total = this.free_plan_videos_count;
          this.feeds_total = this.free_plan_videos_count;
        } else if (this.userSubType == 1) {
          this.plan = 'Starter';
          this.views_total = this.starter_plan_views_count;
          this.slicks_total = this.starter_plan_videos_count;
          this.feeds_total = this.starter_plan_videos_count;
        } else if (this.userSubType == 2) {
          this.plan = 'Pro';
          this.views_total = this.pro_plan_views_count;
          this.slicks_total = this.pro_plan_videos_count;
          this.feeds_total = this.pro_plan_videos_count;
        } else if (this.userSubType == 3) {
          this.plan = 'Enterprise';
          this.views_total = this.enterprise_plan_views_count;
          this.slicks_total = this.enterprise_plan_videos_count;
          this.feeds_total = this.enterprise_plan_videos_count;
        } else {

        }
    });

    toObservable(plansResource.error, { injector: this.injector }).pipe(
      filter((error): error is any => error !== null)
    ).subscribe(error => {
        this.errorHandler.handle(error);
    });
  }
  getCategoryLabel(category: string): string {
    switch (category.toUpperCase()) {
      case 'IMAGE':
        return 'Imagens';
      case 'REELS':
        return 'Reels';
      case 'CAROUSEL_ALBUM':
        return 'Carrossel';
      case 'VIDEO':
        return 'Vídeos';
      default:
        return category;  // Mantém o original se não tiver mapeamento.
    }
  }
  getCategoryClass(category: string): string {
    switch (category.toUpperCase()) {
      case 'IMAGE':
        return 'bg-indigo-50 text-indigo-900';
      case 'VIDEO':
        return 'bg-indigo-50 text-indigo-900';
      case 'CAROUSEL_ALBUM':
        return 'bg-indigo-50 text-indigo-900';
      case 'REELS':
        return 'bg-indigo-50 text-indigo-900';
      default:
        return 'bg-indigo-100 text-indigo-800';
    }
  }

  getCategoryIcon(category: string): string {
    switch (category.toUpperCase()) {
      case 'IMAGE':
        return 'pi pi-image';
      case 'VIDEO':
        return 'pi pi-video';
      case 'CAROUSEL_ALBUM':
        return 'pi pi-images';
      case 'REELS':
        return 'pi pi-play';
      default:
        return 'pi pi-tag';
    }
  }
  onFeedAccountSelecionada(
    selection: any,
    feed: Feed
  ) {
    const src = (feed.source_id || '').toLowerCase();
    if (src === 'tiktok' || src === 'tt') {
      const novoOpenId = selection.instagramId; // No TikTok, é o open_id
      if (!novoOpenId) {
        console.warn('Seleção inválida (TikTok):', selection);
        this.messageService.add({
          severity: 'warn',
          summary: 'Seleção inválida',
          detail: 'Selecione uma conta do TikTok.'
        });
        return;
      }

      const payload = {
        feed_uid: feed.uid,
        new_account_id: novoOpenId
      };

      this.feedService.updateTikTokAccount(payload).subscribe({
        next: () => {
          // Atualize o feed.local ou recarregue contas
          feed.account_id = novoOpenId;
          this.messageService.add({
            severity: 'success',
            summary: 'Conta atualizada',
            detail: 'Conta do TikTok alterada com sucesso.'
          });
        },
        error: (error) => {
          this.errorHandler.handle(error, 'Não foi possível atualizar a conta do TikTok.');
        }
      });
    } else if (src === 'instagram' || src === 'ig') {
      const selected = feed.all_instagram_accounts?.find(acc => acc.id === selection.instagramId) as any;


      if (!selected || !selected.id || !selected.page_id || !selected.facebook_user_id) {
        console.warn('Seleção inválida:', selected);
        return;
      }

      const payload = {
        feed_uid: feed.uid,
        new_facebook_user_id: selected.facebook_user_id,
        instagram_user_id: selected.id,
        page_id: selected.page_id
      };

      this.feedService.updateInstagramAccount(payload).subscribe({
        next: () => {
          feed.selectedInstagramAccount = selected;
          this.messageService.add({
            severity: 'success',
            summary: 'Conta atualizada',
            detail: 'A conta do Instagram foi atualizada com sucesso.'
          });
        },
        error: (error) => {
          this.errorHandler.handle(error, 'Não foi possível atualizar a conta do Instagram.');
        }
      });
    } else if (src === 'youtube' || src === 'yt') {
      // Verifica o tipo do feed (igual dropdownOptions)
      if (feed.feed_type === 'canal' || feed.feed_type === 'hashtag') {
        // Troca apenas a conta Google associada ao feed
        const newGoogleAccountId = (selection.googleAccountId || selection.instagramId); // fallback pelo valor emitido
        if (!newGoogleAccountId) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Seleção inválida',
            detail: 'Selecione uma conta do Google.'
          });
          return;
        }
        const payload = {
          feed_uid: feed.uid,
          new_account_id: newGoogleAccountId
        };
        this.feedService.updateGoogleAccount(payload).subscribe({
          next: () => {
            feed.account_id = newGoogleAccountId;
            this.messageService.add({
              severity: 'success',
              summary: 'Conta Google atualizada',
              detail: 'Conta do Google/YouTube alterada com sucesso.'
            });
          },
          error: (error) => {
            this.errorHandler.handle(error, 'Não foi possível atualizar a conta do Google.');
          }
        });
      } else if (feed.feed_type === 'liked' || feed.feed_type === 'personal_media') {
        // Troca canal do YouTube (precisa do accountId da conta Google e channelId do canal)
        const newGoogleAccountId = selection.googleAccountId;
        const newChannelId = selection.youtubeChannelId || selection.instagramId;
        if (!newGoogleAccountId || !newChannelId) {
          this.messageService.add({
            severity: 'warn',
            summary: 'Seleção inválida',
            detail: 'Selecione um canal do YouTube válido.'
          });
          return;
        }
        const payload = {
          feed_uid: feed.uid,
          new_account_id: newGoogleAccountId,
          channel_id: newChannelId
        };
        this.feedService.updateYouTubeChannel(payload).subscribe({
          next: () => {
            feed.account_id = newGoogleAccountId;
            feed.channel_id = newChannelId;
            this.messageService.add({
              severity: 'success',
              summary: 'Canal atualizado',
              detail: 'Canal do YouTube alterado com sucesso.'
            });
          },
          error: (error) => {
            this.errorHandler.handle(error, 'Não foi possível atualizar o canal do YouTube.');
          }
        });
      }
    }



  }

  onInstagramAccountChange(event: any, feed: Feed) {
    const selected = event.value;
    if (!selected || !selected.id || !selected.page_id || !selected.facebook_user_id) {
      console.warn('Seleção inválida:', selected);
      return;
    }

    const payload = {
      feed_uid: feed.uid,
      new_facebook_user_id: selected.facebook_user_id,
      instagram_user_id: selected.id,
      page_id: selected.page_id
    };

    this.feedService.updateInstagramAccount(payload).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Conta atualizada',
          detail: 'A conta do Instagram foi atualizada com sucesso.'
        });
      },
      error: (error) => {
        this.errorHandler.handle(error, 'Não foi possível atualizar a conta do Instagram.');
      }
    });
  }
  subs_status?: string;
  freePlanPrice!: string;
  starterPlanPrice!: string;
  proPlanPrice!: string;
  enterprisePlanPrice!: string;
  freePlanViews!: string;
  starterPlanViews!: string;
  proPlanViews!: string;
  enterprisePlanViews!: string;
  plan: string = 'Free';
  views_total: number = 500;
  slicks_total: number = 10;
  feeds_total: number = 10;
  free_plan_videos_count: number = 10;
  starter_plan_videos_count: number = 150;
  pro_plan_videos_count: number = 450;
  enterprise_plan_videos_count: number = 999;

  free_plan_views_count: number = 500;
  starter_plan_views_count: number = 15000;
  pro_plan_views_count: number = 50000;
  enterprise_plan_views_count: number = 150000;
  hasShopify!: boolean;
  formatCurrency(value: number): string {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'USD'
    }).format(value);
  }
  // Função para formatar os números de visualizações
  formatNumber(value: number): string {
    return new Intl.NumberFormat('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(value);
  }
  showPlansDialog() {
    this.displayPlans = true;
  }
  closePlansDialog() {
    this.displayPlans = false;
  }
  getStoreData() {
    const domainStore = localStorage.getItem('domain_store');
    this.feedService.getStorneInfos(domainStore ? domainStore : "").subscribe({
      next: (res) => {
      },
      error: (err: any) => {
        console.error('Failed to set meta tags', err);
      }
    });
  }
  displayAguarde: boolean = false;

  onTogglePublish(ingest: any, isPublished: boolean, index: number): void {
    this.displayAguarde = true;

    // Antes chamava /ingest/{uid}/publicar|despublicar (FeedsController::updateIngest),
    // que não tem a checagem de limite do plano (Bacen/PpuBilling/Hookdeck) que
    // /asset/pub e /asset/despub já têm — mesma rota usada pelo publicar/despublicar
    // em massa de slicks-data-view. Unificado pra não ter duas regras de negócio
    // divergentes pro mesmo efeito (publicar/despublicar 1 slick).
    const apiCall = isPublished
      ? this.feedService.publicarSelecionados([ingest.uniq_id])
      : this.feedService.despublicarSelecionados([ingest.uniq_id]);

    apiCall.subscribe({
      next: () => {
        ingest.status = isPublished ? 1 : 0;
        this.recentIngests[index].isPublished = isPublished;

        this.displayAguarde = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: `Ingest “${ingest.uniq_id}” ${isPublished ? 'publicado' : 'despublicado'}.`
        });

        // /asset/pub e /asset/despub não devolvem feed_title/liveShop/feed_uid
        // (ao contrário do endpoint antigo) — usa os dados que o próprio ingest
        // já carrega (live_shop.* + feeds.source_id as feed_source_title, ver
        // FeedsController::index) em vez de esperar isso na resposta.
        const feedSource = (ingest.feed_source_title ?? '').toLowerCase();
        const mediaType = (ingest.media_type ?? '').toLowerCase();
        const targetFeed = this.feeds.find(f => f.id === ingest.feed_id);

        // activeSlicksCount conta TODA fonte (inclusive uploads/'up'), por isso
        // fica fora do if/else de plataforma — só os contadores específicos
        // (instagramPublished/youtubePublished/tiktokPublished) dependem da
        // fonte. Bug anterior: activeSlicksCount só incrementava dentro dos
        // branches ig/yt/tt, então uploads nunca mexia nesse contador.
        if (isPublished) {
          this.activeSlicksCount++;
        } else {
          this.activeSlicksCount--;
        }

        if (feedSource === 'ig') {
          if (isPublished) {
            this.instagramPublished++;
          } else {
            this.instagramPublished--;
          }
        } else if (feedSource === 'yt') {
          if (isPublished) {
            this.youtubePublished++;
          } else {
            this.youtubePublished--;
          }
        } else if (feedSource === 'tt') {
          if (isPublished) {
            this.tiktokPublished++;
          } else {
            this.tiktokPublished--;
          }
        }

        // Atualiza categoria 'reels'/'image' se for o caso
        if (mediaType === 'reels' || mediaType === 'image') {
          const category = this.categoryEntries.find(cat => cat.key.toLowerCase() === mediaType);
          if (category) {
            if (isPublished) {
              category.value++;
            } else {
              category.value--;
            }
          }
        }

        if (targetFeed) {
          if (isPublished) {
            targetFeed.published_count++;
            targetFeed.unpublished_count = Math.max(0, targetFeed.unpublished_count - 1);
          } else {
            targetFeed.published_count = Math.max(0, targetFeed.published_count - 1);
            targetFeed.unpublished_count++;
          }
        }
      },
      error: error => {
        this.displayAguarde = false;
        if (isPublished) {
          this.recentIngests[index].isPublished = 0;
        } else {
          this.recentIngests[index].isPublished = 1;
        }

        this.errorHandler.handle(error, `Não foi possível ${isPublished ? 'publicar' : 'despublicar'} o ingest.`);
        if ((error.status === 403 && error.error?.code === 1) || error.status === 429) {
          this.handleUpgrade('asset');
        }
      }
    });
  }


  getSourceSeverity(source: string): string {
    if (!source) {
      return 'secondary';  // valor padrão para quando não tiver source
    }
    switch (source.toLowerCase()) {
      case 'instagram': return 'instagram';
      case 'ig': return 'instagram';
      case 'tiktok': return 'tiktok';
      case 'youtube': return 'youtube';
      case 'yt': return 'youtube';
      default: return 'secondary';
    }
  }
  irParaAssinatura(): void {
    this.router.navigate(['/profile'], { fragment: 'feed_subs' });
  }
  getStatusSeverity(status: number): 'success' | 'danger' {
    return status === 1 ? 'success' : 'danger';
  }

  getSourceIcon(source: string | null | undefined): string {
    if (!source) {
      return '/assets/icons/default_feed.png';
    }
    switch (source.toLowerCase()) {
      case 'uploads': return '/assets/icons/upload_feed.jpg';
      case 'instagram':
      case 'ig':
        return '/assets/icons/instagram.webp';
      case 'tiktok': case 'tt': return '/assets/icons/tiktok.webp';
      case 'youtube': case 'yt': return '/assets/youtube-color.svg';
      default: return '/assets/icons/default_feed.png';
    }
  }
  mapSourceLabel(source: string): string {
    switch (source) {
      case 'ig':
        return 'Instagram';
      case 'tt':
        return 'Tiktok';
      case 'up':
        return 'Uploads';
      case 'yt':
        return 'Youtube';
      default:
        return source;
    }
  }

  loadFeeds(): void {
    if (!this.nextCursor) {
      return; // não há mais para carregar
    }
    this.feedService.listFeeds(this.limit, this.nextCursor).subscribe({
      next: (payload: ListFeedsPayload) => {
        // concatena novos feeds
        this.feeds = this.feeds.concat(payload.feeds);

        // Pre-popula selectedInstagramAccount com ig_username/ig_picture vindos do backend
        this.feeds.forEach((f: Feed) => {
          if (f.source_id === 'ig' && f.account_id && f.ig_username && !f.selectedInstagramAccount) {
            f.selectedInstagramAccount = {
              id: f.account_id,
              username: f.ig_username,
              picture: f.ig_picture ?? '',
              page_id: ''
            };
          }
        });

        ///////////////////////
        // Bug real (achado testando SSAPP-22 no preview): isso usava
        // f.account_id como se fosse facebook_user_id pra chamar
        // listFacebookPages — só que account_id é o id da conta Instagram
        // Business, não o facebook_user_id (mesma confusão documentada no
        // backend, CronJobsController::ingestFeedProcess()). Resultado: 404
        // em /facebook/pages?fbAccountId=<id errado> pra TODO feed Instagram
        // carregado via paginação, e pior — o catchError devolvia
        // validAccounts:[] e isso sobrescrevia (sem guard) o
        // selectedInstagramAccount que o "pre-popula" acima já tinha
        // acertado, apagando a conta do dropdown. Corrigido usando
        // payload.facebook_user_ids (ids reais, mesma fonte que ngOnInit já
        // usa na carga inicial) em vez de f.account_id.
        const facebookUserIds = payload.facebook_user_ids ?? [];

        from(facebookUserIds).pipe(
          mergeMap((facebookUserId: string) => {
            return this.gallery.listFacebookPages(10, undefined, facebookUserId).pipe(
              switchMap((res: any) => {
                const pages = res.data;
                const calls = pages.map((page: any) =>
                  this.gallery.getInstagramAccountForPage(page.id, facebookUserId).pipe(
                    map((acc: any): (InstagramBusinessAccount & { page_id: string }) | null =>
                      acc ? { ...acc, page_id: page.id, facebook_user_id: facebookUserId } : null
                    ),
                    catchError(() => of(null))
                  )
                );

                return forkJoin(calls as Observable<(InstagramBusinessAccount & { page_id: string }) | null>[])
                  .pipe(
                    map((results) => ({
                      facebookUserId,
                      validAccounts: results.filter(
                        (acc): acc is InstagramBusinessAccount & { page_id: string } =>
                          acc !== null && !!acc.id
                      )
                    }))
                  );
              }),
              catchError(() =>
                of({
                  facebookUserId,
                  validAccounts: [] as (InstagramBusinessAccount & { page_id: string })[]
                })
              )
            );
          }),
          filter((res): res is { facebookUserId: string; validAccounts: (InstagramBusinessAccount & { page_id: string })[] } => !!res)
        ).subscribe({
          next: ({ facebookUserId, validAccounts }) => {
            // 1) Armazena no Map global
            this.globalInstagramAccounts.set(facebookUserId, validAccounts);

            // 2) Atualiza feeds com contas específicas
            this.feeds
              .filter((f: Feed) => f.account_id === facebookUserId)
              .forEach((f: Feed) => {
                f.instagram_accounts = validAccounts;
                f.selectedInstagramAccount = f.selectedInstagramAccount ?? (validAccounts.find(
                  (acc: InstagramBusinessAccount & { page_id: string }) => acc.username === f.instagram_username
                ) || validAccounts[0]);
              });

            // 3) Atualiza todos os feeds com todas as contas
            const allAccounts = Array.from(this.globalInstagramAccounts.values()).flat();

            this.feeds.forEach((f: Feed) => {
              f.all_instagram_accounts = allAccounts;
            });
          },
          complete: () => {
            console.log('Todas as requisições de contas Meta finalizadas');
          }
        });

        ///////////////////////
        // atualiza cursor (ou fecha botão)
        this.nextCursor = payload.nextCursor;
        // recalcula métricas sobre o array completo
        this.recalculateMetrics();
      },
      error: err => console.error('Erro ao carregar mais feeds', err)
    });
  }

  private recalculateMetrics() {
    // Feeds totais publicados e total geral
    this.activeSlicksCount = this.feeds.reduce((sum, f) => sum + f.published_count, 0);
    this.progressValue = this.activeSlicksCount / this.maxSlicks * 100;
    this.allPublished = this.activeSlicksCount;
    this.allTotal = this.feeds.reduce((sum, f) => sum + f.published_count + f.unpublished_count, 0);
    // Upload
    const uploadFeeds = this.feeds.filter(f => f.title.toLowerCase().includes('upload'));
    this.uploadTotal = uploadFeeds.reduce((sum, f) => sum + f.published_count + f.unpublished_count, 0);
    // Instagram
    const instaFeeds = this.feeds.filter(f => f.title.toLowerCase() === 'instagram');

    //////////////////
    this.uploadPublished = this.payload.liveShopsUploadCountPublished;
    this.instagramPublished = this.payload.liveShopsInstagramCountPublished;
    this.youtubePublished = this.payload.liveShopsInstagramCountPublished;
    this.tiktokPublished = this.payload.liveShopsTiktokCountPublished;
    //////////////////


    this.instagramTotal = instaFeeds.reduce((sum, f) => sum + f.published_count + f.unpublished_count, 0);
    // TikTok
    const tikFeeds = this.feeds.filter(f => f.title.toLowerCase() === 'tiktok');
    this.tiktokTotal = tikFeeds.reduce((sum, f) => sum + f.published_count + f.unpublished_count, 0);
    // Contagem das cards de métricas
    this.uploadCount = this.payload.liveShopsUploadCount;

    this.instagramCount = this.payload.liveShopsInstagramCount;
    this.youtubeCount = this.payload.liveShopsYoutubeCount;

    this.tiktokCount = this.payload.liveShopsTiktokCount;
  }

  private calcMaxSlicks(subType: number): number {
    switch (subType) {
      case 1: return 150;
      case 2: return 450;
      case 3: return 600;
      default: return 10;
    }
  }

  getItemActionMenu(feed: Feed): MenuItem[] {
    const isActive = feed.status === 1;
    const isOn = feed.moderation === 1;
    return [
      {
        label: 'Listar',
        icon: 'pi pi-list',
        command: () => this.onListFeed(feed)
      },
      {
        label: isActive ? 'Inativar' : 'Ativar',
        icon: isActive ? 'pi pi-times-circle' : 'pi pi-check-circle',
        disabled: feed.is_deletable === 0,
        command: () => this.onToggleFeedStatus(feed)
      },
      {
        label: 'Auto-publicar',
        icon: isOn ? 'pi pi-times-circle' : 'pi pi-check-circle',
        styleClass: isOn ? 'text-green-500' : 'text-red-500',
        disabled: feed.is_deletable === 0,
        command: () => this.onToggleAutoPublish(feed)
      },
      {
        label: 'Editar filtros',
        icon: 'pi pi-filter',
        command: () => this.onEditFilters(feed)
      },
      {
        label: 'Deletar',
        icon: 'pi pi-trash',
        disabled: feed.is_deletable === 0,
        command: () => this.onDeleteFeed(feed)
      }
    ];
  }

  // SSAPP-7/SSAPP-20: resumo compacto dos filtros de um feed pro card —
  // reaproveita as mesmas funções puras usadas pelo builder
  // (feed-filter-rule.model.ts). Um chip por GRUPO (não por regra) — um
  // grupo com 2+ regras já vem resumido entre parênteses por
  // summarizeFeedFilterGroup. Sem truncar por quantidade de grupos — a linha
  // de chips tem scroll lateral (mesmo padrão da linha de tipo de mídia),
  // então mostra todos os grupos por completo.
  hasFeedFilters(feed: Feed): boolean {
    return getFeedFilterGroups(feed.filters).length > 0;
  }

  // SSAPP-22: sem isso, o *ngFor de feeds recria o <account-selector> de cada
  // card do zero toda vez que this.feeds é reatribuído com objetos novos
  // (ex. paginação em loadFeeds()) — porque o *ngFor por padrão compara por
  // identidade de objeto. Isso reseta o estado interno do account-selector
  // (ngOnInit dispara de novo), visível como o dropdown de conta do
  // Instagram "esvaziando" — TikTok/YouTube não sofrem o mesmo porque
  // resolvem a conta a partir de accountId/channelId (campos crus,
  // estáveis), não de um objeto enriquecido vindo do componente pai.
  trackByFeedUid(_index: number, feed: Feed): string {
    return feed.uid;
  }

  getFeedFilterChips(feed: Feed): string[] {
    return getFeedFilterGroups(feed.filters).map(summarizeFeedFilterGroup);
  }

  private onListFeed(feed: Feed) {
    this.router.navigate(['/slicks'], {
      queryParams: { feed_uid: feed.uid }
    });
  }
  private onToggleFeedStatus(feed: Feed) {
    this.displayAguarde = true;


    if (feed.status == 1) { // toggleFeedStatusInactive
      this.feedService.toggleFeedStatusInactive(feed.uid).subscribe({
        next: updated => {
          this.displayAguarde = false;
          // atualiza o status local para re-renderizar o menu
          feed.status = updated.status;
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: `Status do feed “${feed.title}” atualizado.`
          });
          this.activeFeedsCount = this.activeFeedsCount - 1;
          //this.updateFeeds();
        },
        error: error => {
          this.displayAguarde = false;
          this.errorHandler.handle(error, `Não foi possível atualizar o status de “${feed.title}”.`);
        }
      });
    } else {
      this.feedService.toggleFeedStatus(feed.uid).subscribe({
        next: updated => {
          this.displayAguarde = false;
          // atualiza o status local para re-renderizar o menu
          feed.status = updated.status;
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: `Status do feed “${feed.title}” atualizado.`
          });
          this.activeFeedsCount = this.activeFeedsCount + 1;
          //this.updateFeeds();
        },
        error: error => {
          this.displayAguarde = false;
          if (error.status == 403 && error.error?.code === 1) {
            this.handleUpgrade('feed');
          } else {
            this.errorHandler.handle(error, `Não foi possível atualizar o status de “${feed.title}”.`);
          }

        }
      });
    }


  }
  getAutoPublishMenu(feed: Feed): MenuItem[] {
    const isOn = feed.moderation === 1;
    return [
      {
        label: 'Auto-publicar',
        icon: isOn ? 'pi pi-times-circle' : 'pi pi-check-circle',
        styleClass: isOn ? 'text-green-500' : 'text-red-500',
        command: () => this.onToggleAutoPublish(feed)
      }
    ];
  }

  onToggleAutoPublish(feed: Feed) {
    // dispara a chamada e aguarda o retorno do servidor
    this.feedService
      .onToggleAutoPublish(feed.uid)
      .subscribe({
        next: (updated: Feed) => {
          this.displayAguarde = false;         // 2) fecha o diálogo
          feed.moderation = updated.moderation;       // 3) atualiza local
          this.messageService.add({                  // 4) toast de sucesso
            severity: 'success',
            summary: 'Sucesso',
            detail: `Auto-publicação ${updated.moderation === 1 ? 'ativada' : 'desativada'}.`
          });
        },
        error: (error: any) => {
          this.displayAguarde = false;         // fecha o diálogo
          this.errorHandler.handle(error, 'Não foi possível alternar auto-publicação.');
        }
      });
  }

  getTypeIcon(type: string): string {
    switch (type) {
      case 'IMAGE': return 'pi pi-image';
      case 'VIDEO': return 'pi pi-video';
      case 'REEL': return 'pi pi-video-plus';
      case 'CAROUSEL_ALBUM': return 'pi pi-th-large';
      default: return 'pi pi-tag';
    }
  }

  getTypeSeverity(type: string): string {
    switch (type) {
      case 'IMAGE': return 'info';
      case 'VIDEO': return 'help';
      case 'REEL': return 'warning';
      case 'CAROUSEL_ALBUM': return 'success';
      default: return 'secondary';
    }
  }
  // SSAPP-22: antes deletar um feed chamava updateFeeds(), que refazia
  // listFeeds() inteiro e RECONSTRUÍA this.feeds com objetos novos vindos do
  // backend — mesmo com trackBy + restauração de campos, o account-selector
  // de feeds Instagram voltava a resetar às vezes (o "pre-popula" usa
  // f.account_id, que é o facebook_user_id, não o id da conta Instagram; sem
  // a resolução assíncrona rodando de novo pra contas já conhecidas, esse
  // valor errado nunca era corrigido). Causa raiz: não precisávamos
  // reconstruir this.feeds pra deletar um item — já é filtrado localmente em
  // onDeleteFeed antes de chamar isso. Só os agregados que o próprio backend
  // calcula (contadores por fonte, categorias, ingests recentes, cursor)
  // dependem de um refetch; this.feeds e os account-selector's de cada card
  // ficam intocados, então não há mais como esse dropdown resetar.
  private refreshFeedAggregatesAfterDelete(): void {
    this.feedService.listFeeds(this.limit, undefined).subscribe({
      next: (payload: ListFeedsPayload) => {
        this.nextCursor = payload.nextCursor;
        this.recentIngests = payload.ingests;
        this.categories = payload.categories;
        this.categoryEntries = Object.entries(this.categories).map(([key, value]) => ({ key, value }));

        this.activeFeedsCount = payload.activeFeedsCount;
        this.progressValueFeeds = this.activeFeedsCount / this.maxSlicks * 100;

        this.payload = payload;
        this.uploadCount = payload.liveShopsUploadCount;
        this.instagramCount = payload.liveShopsInstagramCount;
        this.youtubeCount = payload.liveShopsYoutubeCount;
        this.tiktokCount = payload.liveShopsTiktokCount;

        this.uploadPublished = payload.liveShopsUploadCountPublished;
        this.instagramPublished = payload.liveShopsInstagramCountPublished;
        this.youtubePublished = payload.liveShopsYoutubeCountPublished;
        this.tiktokPublished = payload.liveShopsTiktokCountPublished;
      },
      error: err => console.error('Erro ao atualizar agregados após deletar feed', err)
    });
  }


  private onDeleteFeed(feed: Feed) {
    this.confirmationService.confirm({
      message: `Tem certeza que deseja deletar o feed “${feed.title}”?`,
      header: 'Confirmação de Exclusão',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.displayAguarde = true;
        this.feedService.deleteFeed(feed.uid)
          .subscribe({
            next: () => {
              this.displayAguarde = false;
              // ✅ Remove o feed deletado da lista
              this.feeds = this.feeds.filter(f => f.uid !== feed.uid);

              if (feed.status === 1) {
                this.activeFeedsCount = this.feeds.filter(f => f.status === 1).length;
                this.progressValueFeeds = this.activeFeedsCount / this.maxSlicks * 100;
              }

              this.refreshFeedAggregatesAfterDelete();
              this.messageService.add({
                severity: 'success',
                summary: 'Sucesso',
                detail: `Feed “${feed.title}” deletado.`
              });
              // aqui, remova o feed da lista, se necessário
            },
            error: error => {
              this.displayAguarde = false;
              this.errorHandler.handle(error, `Não foi possível deletar o feed “${feed.title}”.`);
            }
          });
      },
      reject: () => {
        // não faz nada se cancelar
      }
    });
  }



  getFeedIcon(source: string): string {

    switch (source.toLowerCase()) {
      case 'uploads': return '/assets/icons/upload_feed.jpg';
      case 'instagram':
      case 'ig':
        return '/assets/icons/instagram.webp';
      case 'yt':
        return '/assets/youtube-color.svg';
      case 'tiktok': case 'tt': return '/assets/icons/tiktok.webp';
      default: return '/assets/icons/default_feed.png'; // um ícone “genérico”
    }
  }

  /**
 * Retorna a classe de ícone para cada tag.
 */
  getTagIcon(tag: string): string {
    const t = tag.trim().toLowerCase();
    if (t.startsWith('#')) {
      return 'bi bi-hash';           // hashtag
    }
    if (t === 'imagens') {
      return 'pi pi-image';          // imagem
    }
    if (t === 'vídeos' || t === 'videos') {
      return 'pi pi-video';          // vídeo
    }
    if (t === 'stories') {
      return 'pi pi-star';           // algo que lembre “stories”
    }
    return 'pi pi-tag';              // fallback genérico
  }

  getCleanedTags(feed: any): string[] {
    return (feed?.type || '')
      .split(',')
      .map((t: any) => t.trim())
      .filter((t: any) => !t.startsWith('#'));
  }
  getUnicodeIcon(tag: string): string {
    const t = tag.trim().toLowerCase();
    if (t.startsWith('#')) {
      return '#';                // ou '🔀', '🔖'…
    }
    if (t === 'imagens' || t === 'image') {
      return '🖼️';
    }
    if (t === 'vídeos' || t === 'videos' || t == 'video') {
      return '🎞️';
    }
    if (t === 'stories') {
      return '▯';                // U+25AF, retângulo
    }
    if (t === 'reels' || t === 'reel') {
      return '▶️';               // U+25B6, “play”
    }
    if (t === 'tag' || t === 'Tag') {
      return '🏷';               // U+25B6, “play”
    }
    if (t === 'personal_media' || t === 'tiktok_media') {
      return '🗂️';               // U+25B6, “play”
    }

    if (t === 'liked') {
      return '👍';               // U+25B6, “play”
    }
    if (t === 'canal') {
      return '📺';               // U+25B6, “play”
    }
    return '';                   // sem ícone
  }
  hasType(feed: any, type: string): boolean {
    return (feed.type || '').toLowerCase().split(',').map((t: any) => t.trim()).includes(type.toLowerCase());
  }
  showGaleriaSidebar = false;
  showSelectFont = false;
  openModalFont() {
    this.showSelectFont = true;
  }
  feedSource?: any;
  openGaleria(source: any) {

    this.feedSource = source;
    this.showGaleriaSidebar = true;
    this.showSelectFont = false;
  }
  closeGaleria() {
    this.showGaleriaSidebar = false;
  }
  showContent: boolean = false;
  // propriedades para armazenar os JSONs recebidos
  hashTagJson: any[] = [];
  tagsJson: any[] = [];
  mediaJson: any[] = [];
  storiesJson: any[] = [];
  onHashTagJson(data: any[]) {
    this.hashTagJson = data;
    // chamar EP de criar slicks em massa
  }

  onTagsJson(data: any[]) {
    this.tagsJson = data;
    // chamar EP de criar slicks em massa
  }

  onMediaJson(data: any[]) {
    this.mediaJson = data;
    // chamar EP de criar slicks em massa
  }

  onStoriesJson(data: any[]) {
    this.storiesJson = data;
    // chamar EP de criar slicks em massa

  }
  public autoPublish = false;

  @ViewChild(GaleriaComponent) galeria!: GaleriaComponent;
  loadingSearch: boolean = false;

  // SSAPP-5: estado dos filtros avançados, alimentado pelo app-feed-filter-builder.
  currentFeedFilters?: FeedFilterTree;
  feedFiltersValid = true;

  // SSAPP-7: dialog de edição dos filtros de um feed já criado — estado
  // isolado do de criação acima (mesmo componente app-feed-filter-builder,
  // segunda instância). editFiltersDraft só é aplicado a editFiltersFeed no
  // sucesso do PATCH — cancelar/fechar nunca toca em feed.filters.
  editFiltersFeed: Feed | null = null;
  editFiltersVisible = false;
  editFiltersDraft?: FeedFilterTree;
  editFiltersValid = true;
  editFiltersSaving = false;

  onEditFilters(feed: Feed): void {
    this.editFiltersFeed = feed;
    this.editFiltersDraft = undefined;
    this.editFiltersValid = true;
    this.editFiltersVisible = true;
  }

  saveFeedFilters(): void {
    const feed = this.editFiltersFeed;
    if (!feed || feed.id === undefined || !this.editFiltersValid || this.editFiltersSaving) return;

    this.editFiltersSaving = true;
    this.feedService.updateFeed(feed.id, { filters: this.editFiltersDraft ?? null }).pipe(
      finalize(() => this.editFiltersSaving = false)
    ).subscribe({
      next: (updated) => {
        // Fonte de verdade é a resposta do backend, não o rascunho local
        // (ele pode normalizar valores — trim, dedup — antes de persistir).
        feed.filters = updated.filters ?? [];
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Filtros do feed atualizados.'
        });
        this.editFiltersVisible = false;
      },
      error: (error: any) => {
        this.errorHandler.handle(error, 'Não foi possível salvar os filtros do feed.');
      }
    });
  }

  cancelEditFilters(): void {
    if (this.editFiltersSaving) return;
    this.editFiltersVisible = false;
  }

  addFeed() {
    // Checagem defensiva — o botão já fica [disabled]="!canAddFeed", mas
    // addFeed() não deve confiar só no estado visual do botão.
    if (!this.canAddFeed) return;

    const g = this.galeria;
    const isInstagram = g.source === 'instagram';
    const isTikTok = g.source === 'tiktok';
    const isGoogle = g.source === 'google';

    // Pega referência correta
    const igComp = isInstagram ? g.getInstagramGalleryComp() : null;
    const googleComp = isGoogle ? g.googleGallery : null;

    // 1) determina o type
    let type = '';
    if (isInstagram && igComp) {
      switch (igComp.activeTab.label) {
        case 'HashTag': type = 'hashtag'; break;
        case 'Tags': type = 'tag'; break;
        case 'Mídias': type = 'personal_media'; break;
        case 'Stories': type = 'stories'; break;
      }
    } else if (isTikTok) {
      type = 'tiktok_media';
    } else if (isGoogle && googleComp) {
      switch (googleComp.activeTab.label) {
        case 'Hashtag': type = 'hashtag'; break;
        case 'Mídias': type = 'personal_media'; break;
        case 'Canal': type = 'canal'; break;
        case 'Curtidos': type = 'liked'; break;
        case 'Playlist': type = 'playlist'; break;
      }
    }
    this.loadingSearch = true;

    // SSAPI-47/SSAPP-21: as 3 fontes agora buscam e persistem a mídia
    // automaticamente no backend, na própria criação do feed (mesmo padrão
    // que já existia só pro Instagram, SSAPI-35/SSAPP-19) — não precisamos
    // mais buscar nada aqui no navegador nem reenviar via createAssetsFeed()
    // separado.
    this.doCreateFeed(type);
  }


  private doCreateFeed(type: string) {
    const g = this.galeria;
    const isInstagram = g.source === 'instagram';
    const isTikTok = g.source === 'tiktok';
    const isGoogle = g.source === 'google';
    const igComp = isInstagram ? g.getInstagramGalleryComp() : null;
    const googleComp = isGoogle ? g.googleGallery : null;

    let media_type = '';
    if (isInstagram && igComp) {
      if (type === 'hashtag') media_type = igComp.selectedHashtagMediaTypes.join(',');
      else if (type === 'tag') media_type = igComp.selectedTagsMediaTypes.join(',');
      else if (type === 'personal_media') media_type = igComp.selectedMediaTypes.join(',');
      else if (type === 'stories') media_type = igComp.selectedStoriesMediaTypes.join(',');
    } else if (isTikTok) {
      media_type = 'video'; // ou 'VIDEO', depende do que seu backend espera
    } else if (isGoogle && googleComp) {
      if (type === 'hashtag') media_type = googleComp.selectedHashtagMediaTypes.join(',');
      else if (type === 'personal_media') media_type = googleComp.selectedMediaTypes.join(',');
      else if (type === 'canal') media_type = googleComp.selectedChannelMediaTypes.join(',');
      else if (type === 'liked') media_type = googleComp.selectedMediaTypes.join(',');
      else if (type === 'playlist') media_type = 'video';
    }

    // Account_id e outros campos dependentes da fonte
    let account_id = '';
    let hashtag_id = '';
    let hastag_name = '';
    let channel_id = '';
    let playlist_id = '';
    let playlist_title = '';
    let hashtag_search = '';
    if (isInstagram && igComp) {
      account_id = igComp.selectedInstagramAccountId || '';
      hashtag_id = type === 'hashtag' ? (igComp.lastHashtagId || '') : '';
      hastag_name = type === 'hashtag' ? igComp.hashtag : '';
      hashtag_search = type === 'hashtag' ? igComp.mediaMode : '';
    } else if (isTikTok) {
      account_id = g.selectedTikTokOpenId || '';
      hashtag_id = '';
      hastag_name = '';
      hashtag_search = '';
    } else if (isGoogle && googleComp) {
      account_id = googleComp.selectedGoogleAccountId || '';
      // Aqui você pode adicionar mais campos se desejar
      hashtag_id = '';
      hastag_name = type === 'hashtag' ? googleComp.hashtag : '';
      hashtag_search = '';
      // SSAPP-21: antes vinha do primeiro item buscado no navegador
      // (galleryItems), que sempre chega vazio agora que a busca é 100%
      // backend (SSAPI-47) — selectedChannelId já é a mesma fonte que
      // loadUserMedia()/loadChannelMedia() usavam internamente pra decidir
      // se podiam buscar, então já está disponível antes de qualquer busca.
      channel_id = googleComp.selectedChannelId || '';
      playlist_id = googleComp.selectedPlaylist || '';
      playlist_title = googleComp.playlistsOptions?.find(p => p.value === playlist_id)?.label || '';
    }

    const moderation = g.autoPublish ? 1 : 0;
    let newFeedUid: string = '';
    this.loadingSearch = true;
    this.feedService.createFeed({
      source_id: isTikTok ? 'tt' : isGoogle ? 'yt' : 'ig',
      title: isTikTok ? 'TikTok' : isGoogle ? 'YouTube' : 'Instagram',
      type,
      media_type,
      account_id,
      moderation,
      hashtag_id,
      hastag_name,
      hashtag_search,
      // Instagram (SSAPI-35): controla se os assets que o backend já vai
      // buscar/persistir nesta mesma chamada nascem publicados ou
      // pendentes de moderação — mesmo valor que antes ia só pro
      // createAssetsFeed() separado.
      auto_publish: g.autoPublish,
      ...(isGoogle && channel_id ? { channel_id } : {}),
      ...(isGoogle && type === 'playlist' && playlist_id ? { playlist_id, playlist_title } : {}),
      // SSAPP-5: omite a chave inteira quando não há filtro configurado —
      // mesmo contrato já testado em feed.service.spec.ts (createFeed sem
      // 'filters' no body quando o campo não é passado).
      ...(this.currentFeedFilters ? { filters: this.currentFeedFilters } : {}),
    }).pipe(
      tap(newFeed => {
        newFeedUid = newFeed.uid;
      }),
      catchError(error => {
        this.loadingSearch = false;
        if ((error.status === 403 && error.error?.code === 1) || error.status === 429) {
          this.handleUpgrade('feed');
        } else {
          this.errorHandler.handle(error, 'Não foi possível criar o feed.');
        }
        return EMPTY;
      }),
      finalize(() => this.loadingSearch = false)
    ).subscribe({
      next: newFeed => {
        this.loadingSearch = false;
        // SSAPI-47: as 3 fontes buscam e persistem a mídia no backend, na
        // própria criação do feed — newFeed já traz published_count/
        // unpublished_count direto, sem precisar de um POST separado.
        const publishedCount = newFeed?.published_count ?? 0;
        const unpublishedCount = newFeed?.unpublished_count ?? 0;
        if (newFeed && (publishedCount > 0 || unpublishedCount > 0)) {
          this.messageService.add({
            severity: 'success',
            summary: 'Assets criados',
            detail: `Publicado: ${publishedCount}, Não publicados: ${unpublishedCount}`
          });
        } else {
          this.messageService.add({
            severity: 'info',
            summary: 'Feed criado',
            detail: 'Nenhum asset encontrado para criar.'
          });
        }
        // state (não query param) — sinal de uso único pro aviso em
        // LivesComponent de que mais itens podem chegar em instantes (o
        // resto além do lote síncrono é processado via fila em background,
        // SSAPI-45/47/49); não deve persistir num refresh da página.
        this.router.navigate(['/slicks'], {
          queryParams: { feed_uid: newFeedUid },
          state: { justCreatedFeed: true }
        });


      },
      error: error => {
        this.loadingSearch = false;
        if ((error.status === 403 && error.error?.code === 1) || error.status === 429) {
          this.handleUpgrade('asset');
        } else {
          this.errorHandler.handle(error, 'Não foi possível criar os assets do feed.');
        }
      }
    });
  }

  showUpgradeDialog = false;
  upgradeDialogTitle = '';
  upgradeDialogMessage = '';

  handleUpgrade(type: 'feed' | 'asset', count?: number) {

    this.upgradeDialogTitle = type === 'feed'
      ? `Você atingiu seu limite de feeds ativos.`
      : `Você atingiu seu limite de slicks ativos.`;

    this.upgradeDialogMessage = 'Gostaria de alterar seu plano e aumentar seus limites de uso?';
    // ⚠️ Se já estava aberto, força fechar e reabrir no próximo ciclo.
    this.showUpgradeDialog = false;

    // ⚠️ Deixa o Angular perceber a mudança no próximo ciclo.
    setTimeout(() => {
      this.showUpgradeDialog = true;
    });
  }
  // SSAPP-5: filtros avançados são validados à parte (feedFiltersValid, vindo
  // do app-feed-filter-builder) e combinados aqui — lógica original de
  // conta/hashtag/canal/playlist por origem preservada sem alteração.
  get canAddFeed(): boolean {
    return this.baseCanAddFeed && this.feedFiltersValid;
  }

  private get baseCanAddFeed(): boolean {
    const g = this.galeria;
    if (!g) return false;

    // ✅ Caso TikTok: deve ter conta TikTok selecionada
    if (g.source === 'tiktok') {
      return !!g.selectedTikTokOpenId;
    }

    if (g.source === 'instagram') {
      if (!g?.selectedFacebookAccountId || !g?.selectedInstagramAccountId) {
        return false;
      }
      if (g.activeTab.label === 'HashTag' && !g.hashtag) {
        return false;
      }
    }

    // Google
    if (g.source === 'google') {
      const google = g.googleGallery;
      if (!google) return false;

      // 1. Precisa ter uma conta Google selecionada
      if (!google.selectedGoogleAccountId) return false;

      // NOVA REGRA: Playlist
      if (google.activeTab?.label === 'Playlist') {
        if (google.privatePlaylists) {
          // modo privado: precisa canal selecionado + playlist escolhida
          return !!google.selectedChannelId && !!google.selectedPlaylist;
        } else {
          // modo público: precisa nome/ID do canal digitado + playlist escolhida
          return !!google.targetChannel && !!google.selectedPlaylist;
        }
      }


      // 2. Regras específicas para cada aba
      switch (google.activeTab?.label) {
        case 'Hashtag':
          // Só precisa de hashtag preenchida
          return !!google.hashtag;
        case 'Canal':
          // Só precisa de valor digitado no campo canal
          return !!google.targetChannel;
        case 'Mídias':
        case 'Curtidos':
          // Precisa ter canal selecionado
          return !!google.selectedChannelId;
        default:
          return false;
      }
    }

    return true;
  }
}

